<nz-modal nzClassName="luqta-custom-modal" [(nzVisible)]="isVisible" [nzTitle]="modalTitle" [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()" nzWidth="700px">
  <ng-container *nzModalContent>
    <form [formGroup]="filterForm" class="filter-form">
      <div class="row gy-3">
        <!-- Status -->
        <div class="col-md-6" *ngIf="config.showStatus !== false">
          <label class="form-label">Status</label>
          <nz-select formControlName="status" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let status of (config.statusOptions || defaultStatusOptions)" [nzValue]="status.value"
              [nzLabel]="status.label"></nz-option>
          </nz-select>
        </div>

        <!-- Format -->
        <div class="col-md-6" *ngIf="config.showFormat !== false">
          <label for="contestName" class="form-label">
            {{ "addContests.formatOfContest.label" | translate }}
            <span class="label_subtext">
              <span nz-tooltip nzTooltipTitle="{{
                      'addContests.formatOfContest.tooltip' | translate
                    }}">
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </span>
          </label>
          <nz-select formControlName="format" nzAllowClear nzPlaceHolder="{{
                  'addContests.formatOfContest.placeholder' | translate
                }}" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let format of defaultFormatOptions" [nzValue]="format.value"
              [nzLabel]="format.label"></nz-option>
          </nz-select>
        </div>

        <!-- Type -->
        <div class="col-md-6" *ngIf="config.showType !== false">
          <label for="type" class="form-label">
            {{ "addContests.type.label" | translate }}
            <span class="label_subtext">
              <span nz-tooltip nzTooltipTitle="{{
                      'addContests.type.tooltip' | translate
                    }}">
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </span>
          </label>
          <nz-select formControlName="type" nzAllowClear
            nzPlaceHolder="{{ 'addContests.type.placeholder' | translate }}" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let type of defaultTypeOptions" [nzValue]="type.value"
              [nzLabel]="type.label"></nz-option>
          </nz-select>
        </div>

        <!-- View Type -->
        <div class="col-md-6" *ngIf="config.showViewType !== false">
          <label class="form-label">View Type</label>
          <nz-select formControlName="viewType" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let viewType of (config.viewTypeOptions || defaultViewTypeOptions)"
              [nzValue]="viewType.value" [nzLabel]="viewType.label"></nz-option>
          </nz-select>
        </div>

        <!-- Participant Name (for participants) - 1st -->
        <div class="col-md-6" *ngIf="config.showParticipantName">
          <label class="form-label">Participant Name</label>
          <nz-select formControlName="participant_name" nzAllowClear nzPlaceHolder="Select Participant"
            class="filter-select" nzShowSearch>
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let participant of config.participantNameOptions" [nzValue]="participant.value"
              [nzLabel]="participant.label"></nz-option>
          </nz-select>
        </div>

        <!-- Participant Email (for participants) - 2nd -->
        <div class="col-md-6" *ngIf="config.showParticipantEmail">
          <label class="form-label">Participant Email</label>
          <input type="text" formControlName="participant_email" class="form-control"
            placeholder="Enter participant email" style="height: 38px; border-radius: 8px;" />
        </div>

        <!-- Location - 3rd -->
        <div class="col-md-6" *ngIf="config.showLocation !== false && countryRecords.length > 0">
          <label for="location" class="form-label">
            {{ "addContests.location.label" | translate }}
          </label>
          <nz-select nzMode="multiple" formControlName="location" nzAllowClear nzPlaceHolder="{{
                  'addContests.location.placeholder' | translate
                }}" class="filter-select">
            <nz-option *ngFor="let country of countryRecords" [nzLabel]="country.name"
              [nzValue]="country.name"></nz-option>
          </nz-select>
        </div>

        <!-- Gender (for participants) - 4th -->
        <div class="col-md-6" *ngIf="config.showGender">
          <label class="form-label">Gender</label>
          <nz-select formControlName="gender" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let gender of (config.genderOptions || defaultGenderOptions)" [nzValue]="gender.value"
              [nzLabel]="gender.label"></nz-option>
          </nz-select>
        </div>

        <!-- Payment Status (for billing) -->
        <div class="col-md-6" *ngIf="config.showPaymentStatus">
          <label class="form-label">Payment Status</label>
          <nz-select formControlName="payment_status" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let status of (config.paymentStatusOptions || defaultPaymentStatusOptions)"
              [nzValue]="status.value" [nzLabel]="status.label"></nz-option>
          </nz-select>
        </div>

        <!-- Payment Method (for billing) -->
        <div class="col-md-6" *ngIf="config.showPaymentMethod">
          <label class="form-label">Payment Method</label>
          <nz-select formControlName="payment_method" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let method of (config.paymentMethodOptions || defaultPaymentMethodOptions)"
              [nzValue]="method.value" [nzLabel]="method.label"></nz-option>
          </nz-select>
        </div>

        <!-- Billing Mode (for billing) -->
        <div class="col-md-6" *ngIf="config.showBillingMode">
          <label class="form-label">Billing Mode</label>
          <nz-select formControlName="billing_mode" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let mode of (config.billingModeOptions || defaultBillingModeOptions)"
              [nzValue]="mode.value" [nzLabel]="mode.label"></nz-option>
          </nz-select>
        </div>

        <!-- Plan Type (for billing) -->
        <div class="col-md-6" *ngIf="config.showPlanType">
          <label class="form-label">Plan Type</label>
          <nz-select formControlName="plan_type" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let plan of (config.planTypeOptions || defaultPlanTypeOptions)" [nzValue]="plan.value"
              [nzLabel]="plan.label"></nz-option>
          </nz-select>
        </div>

        <!-- Start Date (for billing) -->
        <div class="col-md-6" *ngIf="config.showStartDate">
          <label class="form-label">Start Date</label>
          <nz-date-picker formControlName="start_date" nzFormat="yyyy-MM-dd" nzAllowClear
            nzPlaceHolder="Select start date" style="width: 100%;"></nz-date-picker>
        </div>

        <!-- End Date (for billing) -->
        <div class="col-md-6" *ngIf="config.showEndDate">
          <label class="form-label">End Date</label>
          <nz-date-picker formControlName="end_date" nzFormat="yyyy-MM-dd" nzAllowClear nzPlaceHolder="Select end date"
            style="width: 100%;"></nz-date-picker>
        </div>

        <!-- Timeline -->
        <div class="col-md-6" *ngIf="config.showTimeline !== false">
          <label class="form-label">
            {{ config.timelineLabel || 'Contest Timeline' }}
            <span class="label_subtext" *ngIf="!config.timelineLabel">
              <span nz-tooltip nzTooltipTitle="{{ 'common.filter-timeline-tooltip' | translate }}">
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </span>
          </label>
          <nz-range-picker formControlName="dateRange" class="date-picker" nzFormat="yyyy-MM-dd" nzAllowClear
            class="w-full" [nzPlaceHolder]="['From', 'To']">
          </nz-range-picker>
        </div>

        <!-- Level -->
        <div class="col-md-6" *ngIf="config.showLevel !== false">
          <label class="form-label">
            Number of levels
            <span class="label_subtext">
              <span nz-tooltip [nzTooltipTitle]="'Levels_Array.Level_timeline_tooltip' | translate">
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </span>
          </label>
          <input type="number" formControlName="level" class="form-control" placeholder="Enter level number"
            style="height: 38px; border-radius: 8px;" min="1" (keydown)="preventNegativeNumberInput($event)"
            (input)="sanitizeLevelInput()" />
        </div>

        <!-- Contest (for participants) -->
        <div class="col-md-6" *ngIf="config.showContest">
          <label class="form-label">Contest</label>
          <nz-select formControlName="contest" nzAllowClear nzShowSearch nzPlaceHolder="All Contests"
            class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let contest of config.contestOptions" [nzValue]="contest.value"
              [nzLabel]="contest.label"></nz-option>
          </nz-select>
        </div>

        <!-- Age (for participants) -->
        <div class="col-md-6" *ngIf="config.showAge">
          <label class="form-label">Age</label>
          <input type="number" formControlName="age" class="form-control" placeholder="Enter age"
            style="height: 38px; border-radius: 8px;" min="1" />
        </div>

        <!-- Completion Rate (for participants) -->
        <div class="col-md-6" *ngIf="config.showCompletionRate">
          <label class="form-label">Completion Rate</label>
          <nz-select formControlName="completionRate" nzAllowClear nzPlaceHolder="All" class="filter-select">
            <nz-option nzLabel="All" nzValue=""></nz-option>
            <nz-option *ngFor="let rate of (config.completionRateOptions || defaultCompletionRateOptions)"
              [nzValue]="rate.value" [nzLabel]="rate.label"></nz-option>
          </nz-select>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-template #modalFooter>
    <div class="d-flex justify-content-between w-100">
      <button type="button" class="btn" (click)="handleReset()" style="background-color: #1f2430; color: #ffffff; border: none; border-radius: 8px; padding: 10px 22px; font-weight: 500;">
        Reset Filters
      </button>
      <button nz-button nzType="primary" class="btn btn-primary" (click)="handleApply()">
        Apply Filters
      </button>
    </div>
  </ng-template>
</nz-modal>